import Vue from "vue";
import Vuex from "vuex";
import SuiVue from 'semantic-ui-vue'
import SemVue from 'semantic-ui-css'
import createPersistedState from 'vuex-persistedstate'
import user from "./modules/user";
// import auth from "./modules/auth";
import auth from "../store/modules/auth/store";
import client from "../views/Clients/store";
import agent from "../views/Agents/store";
import report from "../views/Reports/store";
import mensageria from "../views/Mensageria/store"
import booking from "../views/ReservaExpressa/store"
import product from "../views/Products/store";
import trafx from "../views/Trafx/store";
import login from "../views/Pages/store";
import operacao from "../views/Operacao/store";
import financeiro from "../views/Financeiro/store";
import axios from "axios"

Vue.use(SuiVue);
Vue.use(Vuex);
Vue.use(SemVue);

const dataState = createPersistedState({ 
    storage: window.localStorage,
    paths: ['user', 'auth', 'login', 'client', 'agent', 'product', 'mensageria', /*'report', */ 'booking', 'trafx', 'operacao', 'financeiro']
})

export default new Vuex.Store({
    plugins: [dataState],

    modules: {
        user,
        auth,
        client,
        agent,
        report,
        product,
        mensageria,
        booking,
        trafx,
        operacao,
        login,
        financeiro,
    },

    actions: {
        authLogout({dispatch}, payload) {
            dispatch('auth/logout', payload)
        },
    },

    mutations: {
        SetUser(modules, user) {
            modules.user = user
            if (user) {
                axios.defaults.headers.commom['Authorization'] = `bearer ${user.token}`
            } else {
                delete axios.defaults.headers.commom['Authorization']
            }
        }
    }
});
